let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lAWeK")).then(() => parcelRequire('eb65P'));